var _defs, _circle, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _circle3, _circle4, _path11, _path12, _path13, _path14, _path15, _path16, _circle5, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadSignBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__prefix__undraw_road_sign_mfpo",
    width: 783.131,
    height: 621.673,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__prefix__cls-2{fill:#fff8f1}.prefix__prefix__cls-3{fill:#575a89}.prefix__prefix__cls-4{fill:#f80}.prefix__prefix__cls-5{opacity:.1}.prefix__prefix__cls-6{fill:#2f2e41}.prefix__prefix__cls-8{fill:#f2f2f2}.prefix__prefix__cls-9{fill:#a0616a}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__prefix__Ellipse_78",
    cx: 51.407,
    cy: 51.407,
    r: 51.407,
    fill: "#ff6584",
    "data-name": "Ellipse 78",
    transform: "translate(367.053 28.883)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_474",
    d: "M376.19 415.73c0 99.288-59.025 133.956-131.837 133.956S112.517 515.018 112.517 415.73s131.837-225.6 131.837-225.6S376.19 316.442 376.19 415.73z",
    className: "prefix__prefix__cls-2",
    "data-name": "Path 474",
    transform: "translate(-112.517 -88.031)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_475",
    d: "M145.173 471.477l1.349-83.1 56.192-102.8-55.98 89.765.606-37.363 38.728-74.376L147.5 328.1l1.092-67.2 41.47-59.212-41.3 48.646.682-123.22-4.286 163.12.352-6.729-42.16-64.541 41.487 77.456-3.929 75.05-.117-1.992-48.606-67.917 48.459 74.953-.492 9.386-.088.141.04.77-9.967 190.408h13.317l1.6-98.349 48.339-74.77z",
    className: "prefix__prefix__cls-3",
    "data-name": "Path 475",
    transform: "translate(-18.138 -25.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_476",
    d: "M848.256 338.63c0 121.3-72.11 163.651-161.062 163.651S526.133 459.928 526.133 338.63 687.194 63.021 687.194 63.021s161.062 154.31 161.062 275.609z",
    className: "prefix__prefix__cls-2",
    "data-name": "Path 476",
    transform: "translate(-193.9 -63.021)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_477",
    d: "M590.97 420.7l1.649-101.516L661.268 193.6l-68.39 109.665.742-45.646 47.312-90.862-47.116 78.783 1.333-82.1 50.664-72.338-50.454 59.428L596.192 0l-5.237 199.28.431-8.221-51.509-78.843 50.683 94.624-4.8 91.687-.142-2.433-59.382-82.971 59.2 91.568-.6 11.466-.107.173.049.941L572.6 549.888h16.269l1.953-120.152 59.056-91.344z",
    className: "prefix__prefix__cls-3",
    "data-name": "Path 477",
    transform: "translate(-103.543)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__prefix__Ellipse_79",
    cx: 247.397,
    cy: 8.836,
    className: "prefix__prefix__cls-3",
    "data-name": "Ellipse 79",
    rx: 247.397,
    ry: 8.836,
    transform: "translate(73.871 541.349)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__prefix__Ellipse_80",
    cx: 114.06,
    cy: 10.844,
    className: "prefix__prefix__cls-3",
    "data-name": "Ellipse 80",
    rx: 114.06,
    ry: 10.844,
    transform: "translate(555.011 599.985)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Rectangle_6274",
    d: "M0 0h28.917v271.495H0z",
    className: "prefix__prefix__cls-4",
    "data-name": "Rectangle 6274",
    transform: "translate(306.811 278.69)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_478",
    d: "M521.483 411.759H343.967v-49.8h177.516l51.407 24.9z",
    className: "prefix__prefix__cls-3",
    "data-name": "Path 478",
    transform: "translate(-67.679 -71.219)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_479",
    d: "M521.483 413.35H343.967v4.016h177.516l51.407-24.9-4.145-2.008z",
    className: "prefix__prefix__cls-5",
    "data-name": "Path 479",
    transform: "translate(-67.679 -76.827)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_480",
    d: "M223.374 493.759H400.89v-49.8H223.374l-51.407 24.9z",
    className: "prefix__prefix__cls-3",
    "data-name": "Path 480",
    transform: "translate(-33.836 -87.354)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_481",
    d: "M176.112 472.458l-4.146 2.008 51.407 24.9H400.89v-4.016H223.374z",
    className: "prefix__prefix__cls-5",
    "data-name": "Path 481",
    transform: "translate(-33.836 -92.962)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Rectangle_6275",
    d: "M0 0h30.523v30.523H0z",
    className: "prefix__prefix__cls-4",
    "data-name": "Rectangle 6275",
    transform: "translate(375.889 300.377)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__prefix__Ellipse_81",
    cx: 15.262,
    cy: 15.262,
    r: 15.262,
    className: "prefix__prefix__cls-4",
    "data-name": "Ellipse 81",
    transform: "translate(237.732 366.243)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__prefix__Ellipse_82",
    cx: 8.836,
    cy: 8.836,
    r: 8.836,
    className: "prefix__prefix__cls-6",
    "data-name": "Ellipse 82",
    transform: "translate(312.433 305.197)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__prefix__Ellipse_83",
    cx: 8.836,
    cy: 8.836,
    r: 8.836,
    className: "prefix__prefix__cls-6",
    "data-name": "Ellipse 83",
    transform: "translate(312.433 371.062)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_482",
    d: "M426.743 700.27c0 18.047-10.728 24.349-23.964 24.349q-.46 0-.918-.01a40.189 40.189 0 01-1.821-.083c-11.945-.845-21.225-7.471-21.225-24.256 0-17.37 22.2-39.288 23.864-40.91l.1-.093s23.964 22.955 23.964 41.003z",
    className: "prefix__prefix__cls-4",
    "data-name": "Path 482",
    transform: "translate(-164.914 -180.339)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_483",
    fill: "#3f3d56",
    d: "M405.2 721.858l8.765-12.247-8.784 13.589-.023 1.406a38.679 38.679 0 01-1.82-.083l.945-18.056-.007-.14.016-.026.089-1.705-8.808-13.625 8.836 12.346.021.362.714-13.643-7.544-14.077 7.633 11.685.743-28.284v-.1.094l-.124 22.3 7.508-8.842-7.538 10.764-.2 12.215 7.01-11.723-7.039 13.52-.111 6.791 10.176-16.316-10.215 18.686z",
    "data-name": "Path 483",
    transform: "translate(-168.211 -180.339)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_484",
    d: "M891.911 798.893s-11.373 9.577-17.359 8.979-17.359-.6-12.57 5.986 24.542 10.176 32.922 10.774 26.936 1.2 25.739-2.394-2.394-20.352-7.183-21.549-21.549-1.796-21.549-1.796z",
    className: "prefix__prefix__cls-8",
    "data-name": "Path 484",
    transform: "translate(-259.757 -207.813)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_485",
    d: "M974.239 786.191s-8.381 12.282-14.307 13.314-16.881 4.089-10.5 9.144 26.374 3.206 34.606 1.53 26.267-6.086 24.149-9.224-7.776-18.96-12.71-18.826-21.238 4.062-21.238 4.062z",
    className: "prefix__prefix__cls-8",
    "data-name": "Path 485",
    transform: "translate(-276.809 -204.514)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_486",
    d: "M889.715 565.756s-7.7 52.76-5.908 62.337 2.993 24.542 2.993 24.542-1.2 12.57 0 18.556 8.38 62.852 8.38 64.048-1.2 4.789 0 7.782 3.592.6 0 5.387-1.2 5.986-.6 5.986 23.943 2.394 25.141 0-.6-2.993 0-5.986 1.2-3.591 2.394-4.19 3.591.6 1.8-2.394-5.986-6.585-4.789-8.38-.6-14.965-.6-14.965-1.2-29.331-1.8-47.288 5.387-36.514 5.387-36.514a68.487 68.487 0 0015.563 40.105c15.563 18.556 23.345 53.274 23.345 53.274s3.592 5.387 1.8 10.176-7.183 1.8-1.8 4.789 23.943-1.2 25.739-2.993-2.394-4.19-1.2-8.979 5.986-3.591 1.8-5.986-5.387-1.8-5.387-4.19-10.773-54.473-27.532-69.435l-1.2-54.471s14.964-38.309-.6-41.9-62.926 10.689-62.926 10.689z",
    className: "prefix__prefix__cls-3",
    "data-name": "Path 486",
    transform: "translate(-264.224 -159.723)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_487",
    d: "M904.74 389.12s10.176 25.141 7.781 28.732 29.331-11.971 29.331-11.971-10.176-25.141-10.176-28.133-26.936 11.372-26.936 11.372z",
    className: "prefix__prefix__cls-9",
    "data-name": "Path 487",
    transform: "translate(-268.396 -124.866)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__prefix__Ellipse_84",
    cx: 22.148,
    cy: 22.148,
    r: 22.148,
    className: "prefix__prefix__cls-9",
    "data-name": "Ellipse 84",
    transform: "translate(621.679 226.244)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_488",
    d: "M938.878 400.146s-15.563-1.8-23.345 7.782-8.979 11.972-8.979 11.972S888 449.828 891.59 464.793a43.289 43.289 0 012.394 4.19c1.2 2.394 1.2 35.915 0 41.3s-2.394 7.183-1.2 14.965S883.21 545.6 895.78 548s22.147.6 26.338-4.789.6-8.979 13.767-8.979a31.676 31.676 0 0021.549-8.979s-6.585-7.183-4.19-8.38 0-4.19-1.2-7.183-1.2-5.387.6-5.387.6-1.2-.6-4.19 20.95-54.471 7.782-69.436-19.753-23.345-19.753-23.345 2.397-8.982-1.195-7.186z",
    className: "prefix__prefix__cls-4",
    "data-name": "Path 488",
    transform: "translate(-265.422 -129.307)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_489",
    d: "M902.406 471v26.338l-19.155 63.45s-12.57 32.922 0 32.922 11.9-31.423 11.9-31.423l27.011-47.59s10.775-37.711 9.578-40.7S902.406 471 902.406 471z",
    className: "prefix__prefix__cls-9",
    "data-name": "Path 489",
    transform: "translate(-263.068 -143.295)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_490",
    d: "M917.71 422.559s-17.957 7.183-13.169 26.338 0 18.556 0 18.556 24.542-2.394 32.323 2.993l1.8-7.183s7.179-41.303-20.954-40.704z",
    className: "prefix__prefix__cls-4",
    "data-name": "Path 490",
    transform: "translate(-268.197 -133.763)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_491",
    fill: "#55424c",
    d: "M902 347.313a8.836 8.836 0 01-8.3-1.292 6.687 6.687 0 01-1.887-7.894c1.146-2.249 3.6-3.483 5.949-4.4a55.286 55.286 0 0116.2-3.658c2.648-.188 5.429-.159 7.792 1.051 1.169.6 2.185 1.462 3.343 2.082 2.129 1.14 4.607 1.393 6.908 2.127a17.291 17.291 0 0110.567 9.713 20.83 20.83 0 011.3 4.822 26.852 26.852 0 01-1.4 13.444c-2.551 6.794-7.9 12.733-8.205 19.984-3.276-2.376-4.49-6.666-7.115-9.746a13.258 13.258 0 00-7.566-4.388 4.214 4.214 0 01-2.255-.822 3.63 3.63 0 01-.823-1.921l-2.242-10.582c-.456-2.154-1.033-4.5-2.8-5.81a8.481 8.481 0 00-3.653-1.287 57.3 57.3 0 00-9.358-.853",
    "data-name": "Path 491",
    transform: "translate(-265.732 -115.548)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadSignBlue);
export default __webpack_public_path__ + "static/media/road-sign-blue.437fd4bd0d19e8eab247b55a012466cc.svg";
export { ForwardRef as ReactComponent };